
/**
 * Sticky header.
 */

const sitePrimary = document.querySelector('.site-header__primary');

function createHeaderHeadline() {
  const body = document.querySelector('body');

  if (! body.classList.contains('single')) {
    return null;
  }

  const articleHeadline = document.querySelector('.article-header__headline');
  if (! articleHeadline) {
    return null;
  }

  const sponsored = document.querySelector('.sponsored-notice__text');
  const headerHeadlineEl = document.createElement('h3');
  const headlineOnly = articleHeadline.innerText;
  const headlineText = document.createTextNode(headlineOnly);
  const headlineSpan = document.createElement('span');
  const headerArticleMeta = document.createElement('div');

  if (null !== sponsored) {
    const sponsoredSpan = document.createElement('span');
    sponsoredSpan.setAttribute('class', 'sponsored');
    const sponsoredText = document.createTextNode(sponsored.dataset.header_text); // eslint-disable-line max-len
    sponsoredSpan.appendChild(sponsoredText);
    headerHeadlineEl.appendChild(sponsoredSpan);
  }

  headlineSpan.classList.add('site-header__headline-text');
  headlineSpan.appendChild(headlineText);
  headerHeadlineEl.appendChild(headlineSpan);
  headerHeadlineEl.classList.add('site-header__article-headline');

  headerArticleMeta.classList.add('site-header__article-meta');
  headerArticleMeta.appendChild(headerHeadlineEl);
  return headerArticleMeta;
}

function handleImmersiveHeader() {
  const immersiveClass = document.querySelector('body').classList.contains('immersive-article');
  const featuredClass = document.querySelector('body').classList.contains('featured-article');
  if (immersiveClass || featuredClass) {
    const newHeaderHeadline = createHeaderHeadline();
    const header = document.querySelector('.site-header__primary-menu-container');
    header.appendChild(newHeaderHeadline);
  }
}
window.addEventListener('load', handleImmersiveHeader);

function checkHeaderScroll() {
  // Detect scroll position
  const scrollPosition = Math.round(window.scrollY);

  // If we've scrolled 2px past the leaderboard or the top, add "sticky" class to the header
  const leaderboard = document.getElementById('leaderboard');
  if (2 + leaderboard.offsetHeight < scrollPosition) {
    sitePrimary.classList.add('sticky');
  } else {
    sitePrimary.classList.remove('sticky');
    leaderboard.classList.remove('ad-sticky');
  }
}
window.addEventListener('scroll', checkHeaderScroll);
